import { useEffect, useState } from "react";

/* ─────────────────────────────────────────────
   IMAGE IMPORTS — src/assets/images/blogs/
───────────────────────────────────────────── */
import HeroImg             from "../../assets/images/blogs/ev-trends-india-2021.webp";
import HeroImgMobile       from "../../assets/images/blogs/ev-trends-india-2021-mobile.webp";
import NewsletterBgDesktop from "../../assets/images/blogs/newsletter-bg.webp";
import NewsletterMicMobile from "../../assets/images/blogs/newsletter-bg-mobile.webp";
import ChartImg            from "../../assets/images/blogs/ev-sales-trend-india-oem-2021.webp";

/* ─────────────────────────────────────────────
   ElectricVehicleTrendsInIndiaAndTopSellingEVsIn2021.jsx
   Prefix      : bd-
   Fonts       : Montserrat (headings) | Roboto (body)
   Purple      : #743FAC
   BG main     : #1A1A1A
   Inner pad   : 102px desktop | 32px tab | 16px mobile
   Breaks      : 768px | 480px
   Anim        : IntersectionObserver fade-up
                 delays 0.08s / 0.18s / 0.28s / 0.38s

   DIFF vs other pages:
   - Hero title : LEFT-aligned (not centered), line-height 140%
   - bd-date    : italic small date label above first para
   - bd-caption : small label above inline chart image
   - bd-para--quote : italic quoted paragraph
   - No subheads in body — all bd-para
─────────────────────────────────────────────── */

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800;900&family=Roboto:wght@300;400;500;700&display=swap');

  .bd-wrap *, .bd-wrap *::before, .bd-wrap *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  .bd-wrap {
    font-family: 'Roboto', sans-serif;
    background: #1A1A1A;
    color: #ffffff;
    width: 100%;
    overflow-x: hidden;
  }
  .bd-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
    width: 100%;
  }
  .bd-content-col { width: 100%; }

  /* ── SCROLL FADE-UP ── */
  .bd-fade-up {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .bd-fade-up.bd-in { opacity: 1; transform: translateY(0); }
  .bd-delay-1 { transition-delay: 0.08s; }
  .bd-delay-2 { transition-delay: 0.18s; }
  .bd-delay-3 { transition-delay: 0.28s; }
  .bd-delay-4 { transition-delay: 0.38s; }

  /* ══════════════════════════════════════
     HERO
     title-bar uses bd-inner for padding
     title is LEFT-aligned (this page only)
  ══════════════════════════════════════ */
  .bd-hero { width: 100%; background: #1A1A1A; }
  .bd-hero__title-bar {
    width: 100%;
    background: #1A1A1A;
    padding: 60px 0px;
  }
  .bd-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    text-align: left;
  }
  .bd-hero__img-wrap {
    width: 100%;
    max-height: 600px;
    overflow: hidden;
  }
  .bd-hero__img-wrap img {
    width: 100%;
    height: 100%;
    max-height: 600px;
    object-fit: cover;
    object-position: center;
    display: block;
  }

  /* ══════════════════════════════════════
     BODY CONTENT
  ══════════════════════════════════════ */
  .bd-body-section {
    width: 100%;
    background: #1A1A1A;
    padding: 60px 0 100px;
  }

  /* italic date label */
  .bd-date {
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    font-weight: 400;
    font-style: italic;
    line-height: 160%;
    color: #E2E2E2;
    margin-bottom: 24px;
  }

  .bd-para {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 160%;
    color: #E2E2E2;
    margin-bottom: 24px;
  }
    .bd-para:last-child { margin-bottom: 0px;}

  /* italic quoted paragraph */
  .bd-para--quote {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    
    line-height: 160%;
    color: #E2E2E2;
    margin-bottom: 24px;
  }

  /* small label above chart image */
  .bd-caption {
    font-family: 'Roboto', sans-serif;
    font-size: 20px;
    font-weight: 400;
    color: #FFFFFF;
    line-height:160%;
    margin-bottom: 24px;
  }

  /* chart image — left aligned, 424px */
  .bd-inline-img-wrap {
    margin: 0px 0 44px 0;
    width: 424px;
    max-width: 100%;
  }
  .bd-inline-img-wrap img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 8px;
  }

  /* ══════════════════════════════════════
     NEWSLETTER
  ══════════════════════════════════════ */
  .bd-newsletter {
    width: 100%;
    position: relative;
    overflow: hidden;
    min-height: 520px;
    display: flex;
    align-items: center;
  }
  .bd-newsletter__bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    
    object-position: center;
    z-index: 0;
  }
  .bd-newsletter__overlay {
    position: absolute;
    inset: 0;
    z-index: 1;
  }
  .bd-newsletter__inner {
    position: relative;
    z-index: 2;
    width: 100%;
    max-width: 1600px;
    margin: 0 auto;
    padding: 0px 102px;
  }
  .bd-newsletter__heading {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    line-height: 120%;
    margin-bottom: 14px;
  }
  .bd-newsletter__sub {
    font-family: 'Roboto', sans-serif;
    font-size: 15px;
    color: rgba(255,255,255,0.72);
    line-height: 160%;
    margin-bottom: 24px;
  }
  .bd-newsletter__form {
    display: flex;
    align-items: stretch;
    max-width: 552px;
    gap: 14px;
  }
  .bd-newsletter__input {
    flex: 1;
    height: 48px;
    background: #1A1A1A;
    border: 1px solid #ffffff;
    border-radius: 5px;
    padding: 15px 14px;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    color: #FFFFFF;
    outline: none;
  }
  .bd-newsletter__input::placeholder { color: #FFFFFF; }
  .bd-newsletter__btn {
    height: 50px;
    padding: 15px 30px;
    background: #743FAC;
    border: none;
    border-radius: 5px;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
    transition: background 0.25s ease;
  }
  .bd-newsletter__btn:hover { background: #5e2e90; }
  .bd-newsletter__btn-arrow {
    display: inline-flex;
    align-items: center;
    transition: transform 0.2s ease;
  }
  .bd-newsletter__btn:hover .bd-newsletter__btn-arrow { transform: translateX(4px); }
  .bd-newsletter__mic-img {
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
  }
  .bd-newsletter__content { padding: 0; }

  /* ══════════════════════════
     RESPONSIVE 768px
  ══════════════════════════ */
  @media (max-width: 768px) {
    .bd-inner { padding-left: 32px; padding-right: 32px; }
    .bd-hero__img-wrap img { max-height: 350px; }
    .bd-hero__title-bar { padding: 24px 0px 20px; }
    .bd-hero__title { font-size: 24px; }
    .bd-body-section { padding: 40px 0 48px; }
    .bd-para { margin-bottom: 18px; font-size: 15px; }
    .bd-para--quote { font-size: 15px; margin-bottom: 18px; }
    .bd-date { font-size: 15px; margin-bottom: 18px; }
    .bd-inline-img-wrap { width: 100%; margin: 28px 0; }

    .bd-newsletter {
      min-height: auto;
      align-items: stretch;
      flex-direction: column;
      background: #1A1A1A;
    }
    .bd-newsletter__mic-img { width: 100%; height: 350px; object-fit: cover; }
    .bd-newsletter__inner {
      padding: 0;
      display: flex;
      flex-direction: column;
    }
    .bd-newsletter__content {
      padding: 40px 24px 48px;
      text-align: center;
    }
    .bd-newsletter__heading { font-size: 24px; }
    .bd-newsletter__sub { font-size: 14px; margin: 0 auto 24px; }
    .bd-newsletter__form {
      flex-direction: column;
      max-width: 100%;
      gap: 12px;
    }
    .bd-newsletter__input { border-radius: 5px; height: 44px; }
    .bd-newsletter__btn {
      border-radius: 5px;
      justify-content: center;
      height: 44px;
    }
  }

  /* ══════════════════════════
     RESPONSIVE 480px
  ══════════════════════════ */
  @media (max-width: 480px) {
    .bd-inner { padding-left: 16px; padding-right: 16px; }
    .bd-hero__title-bar { padding: 30px 0px; }
    .bd-body-section { padding: 30px 0 30px; }
    .bd-hero__img-wrap img { max-height: 366px; width: 100%; }
    .bd-hero__title { font-size: 26px; line-height: 120%; }
    .bd-para { font-size: 14px; margin-bottom: 14px; }
    .bd-para--quote { font-size: 14px; margin-bottom: 14px; }
    .bd-date { font-size: 14px; margin-bottom: 14px; }
    .bd-inline-img-wrap { width: 100%; margin: 0px 0 30px 0; }

    .bd-newsletter {
      min-height: auto;
      align-items: stretch;
      flex-direction: column;
      background: #1A1A1A;
    }
    .bd-newsletter__mic-img { width: 100%; height: 366px; object-fit: cover; }
    .bd-newsletter__inner {
      padding: 0;
      display: flex;
      flex-direction: column;
    }
    .bd-newsletter__content {
      padding: 30px 16px 40px;
      text-align: center;
    }
    .bd-newsletter__heading { font-size: 30px; line-height: 120%; }
    .bd-newsletter__sub { font-size: 14px; max-width: 275px; margin: 0 auto 24px; }
    .bd-newsletter__form {
      flex-direction: column;
      max-width: 100%;
      gap: 15px;
      margin-top: 15px;
    }
    .bd-newsletter__input { border-radius: 5px; height: 40px; font-size: 14px; }
    .bd-newsletter__btn {
      border-radius: 5px;
      justify-content: center;
      height: 40px;
      font-size: 14px;
    }
  }
`;

/* ── SCROLL REVEAL ── */
function useScrollReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".bd-fade-up");
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("bd-in"); }),
      { threshold: 0.12 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);
}

/* ── ARROW ── */
function ArrowRight() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

/* ── NEWSLETTER ── */
function Newsletter({ isMobile }) {
  const [email, setEmail] = useState("");
  return (
    <section className="bd-newsletter">
      {!isMobile && (
        <>
          <img className="bd-newsletter__bg" src={NewsletterBgDesktop} alt="" aria-hidden="true" />
          <div className="bd-newsletter__overlay" />
        </>
      )}
      <div className="bd-newsletter__inner">
        {isMobile && (
          <img className="bd-newsletter__mic-img" src={NewsletterMicMobile} alt="Microphone" />
        )}
        <div className="bd-newsletter__content">
          <h2 className="bd-newsletter__heading">Sign up for our<br />newsletter!</h2>
          <p className="bd-newsletter__sub">Get notified about updates and be the first to get early access to new episodes.</p>
          <div className="bd-newsletter__form">
            <input
              className="bd-newsletter__input"
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button className="bd-newsletter__btn">
              Subscribe
              <span className="bd-newsletter__btn-arrow"><ArrowRight /></span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ── ROOT EXPORT ── */
export default function ElectricVehicleTrendsInIndiaAndTopSellingEVsIn2021() {
  useScrollReveal();

  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    setIsMobile(mq.matches);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  const [isSmallMobile, setIsSmallMobile] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 480px)");
    setIsSmallMobile(mq.matches);
    const handler = (e) => setIsSmallMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return (
    <>
      <style>{CSS}</style>
      <div className="bd-wrap">

        {/* HERO — title inside bd-inner, left-aligned */}
        <section className="bd-hero">
          <div className="bd-hero__title-bar">
            <div className="bd-inner">
              <h1 className="bd-hero__title">Electric Vehicle Trends In India And Top Selling EVs in 2021</h1>
            </div>
          </div>
          <div className="bd-hero__img-wrap">
            <img
              src={isSmallMobile ? HeroImgMobile : HeroImg}
              alt="Electric Vehicle Trends India 2021"
            />
          </div>
        </section>

        {/* BODY */}
        <section className="bd-body-section">
          <div className="bd-inner">
            <div className="bd-content-col">

              <p className="bd-date bd-fade-up bd-delay-1">Energizing India Blog, 19th Feb '22</p>

              <p className="bd-para bd-fade-up bd-delay-1">After nearly a decade of hype, there are some signs that the electric-vehicle revolution is finally here. As most automakers around the world produce more electric vehicles in an effort to reduce emissions in the face of stricter regulations, the share of plug-in electric vehicles has steadily increased. Governments promise to prohibit the sale of gas-powered vehicles and advances in charging infrastructure and battery technology mean that the vision of an electrified future is clearer than ever.</p>

              <p className="bd-para bd-fade-up bd-delay-1">As the popularity of electric vehicles grows, pre-orders for new models are breaking records. Global plugin vehicle registrations increased by 70% in 2021 when compared to 2020, totaling 589,000 units (or 8.8 per cent share of the overall auto market). Add in the 600,000-plus plug-in hybrids registered, and we have approximately 18% of the global overall market electrified.</p>

              <p className="bd-para bd-fade-up bd-delay-1">Nowhere in the history of the Indian auto industry has the push for electric vehicles been as strong as it has been in the last few years. There is a strong push to include electric vehicles in the mainstream auto market, from the central government with its FAME II policy and other initiatives to individual states offering substantial EV benefits. On the other hand, technology is evolving at a rapid pace, lowering the price and improving overall packaging, making them as good as, if not better than, conventional IC-engine vehicles. The sales trend of Electric Vehicles in India during the fiscal year 2020-21 (FY21) is a notable case. Throughout this time, the EV market traded from one extreme reality to another. Monthly (or even quarterly) sales that began as abysmally low (due to covid-19-induced disruption) became the highest-ever registered figures by fiscal end.</p>

              <p className="bd-para bd-fade-up bd-delay-1">The past year has demonstrated the impact that subsidies can have on the evolution of a new age industry. The electric vehicle market has been on a positive growth trajectory, and the year 2021 saw significant sales, particularly in the electric two-wheeler category in India. In the 12-month period (January-December) of 2021, total sales of electric two-wheelers, including high-speed and low-speed, increased by 132 percent over the corresponding year in 2020. In 2021, the industry sold 2,33,971 units, compared to 1,00,736 in 2020.</p>

              {/* chart image with caption — image 2 */}
              <div className="bd-inline-img-wrap bd-fade-up bd-delay-2">
                <p className="bd-caption">Electric Vehicle trends in India</p>
                <img src={ChartImg} alt="Electric Vehicle Sales Trend in India by OEM, 2021" />
              </div>

              <p className="bd-para bd-fade-up bd-delay-1">However, with most OEMs announcing manufacturing capacities in the millions of units and total industry sales at just 1% of total ICE two-wheeler sales of an estimated 16 million units, the million-dollar question is how real is demand in the Indian electric two-wheeler industry and do the massive manufacturing capacity announcements from multiple OEMs in the recent past warrant it? Is the e-two-wheeler industry approaching capacity? What about the ecosystem of the supply chain and the charging infrastructure? Nonetheless, both EV start-ups and established OEMs are optimistic that the tide will turn in favour of e-mobility.</p>

              <p className="bd-para bd-fade-up bd-delay-1">The EV buzz is also making headlines. Every day, a new equity infusion, a large number of claimed bookings, or increased manufacturing capacity is announced.</p>

              <p className="bd-para bd-fade-up bd-delay-1">Even though electric passenger vehicle sales account for less than one percent of total passenger vehicle sales in India, there is a strong market preference for electric vehicles at the moment. While only a few automakers have entered this segment, sales figures for the first half of this fiscal year (April-September) stood at 6,261 units, surpassing EV sales of 5,905 units in the previous fiscal year. This is a staggering figure given Indian consumers' continued preference for gasoline-powered vehicles.</p>

              <p className="bd-para bd-fade-up bd-delay-1">Total EV sales of all-electric automakers were 6,261 units in the first two quarters of this fiscal year, particularly from April to September 2021, representing a 234 percent increase over the same period last year. Tata Motors, MG Motors, Hyundai, and Mahindra are market leaders in this segment (Verito). Tata Motors had the most sales in the same time period.</p>

              <p className="bd-para bd-fade-up bd-delay-1">Tata Motors' EV sales remained strong in 2021, with 6,005 units sold across three models — Nexon, Tigor, and the Xpres T EV — bringing the company's seven-month total (April-October) to 6,005. By the end of the year, the company had broken the 10,000-unit barrier, setting a new record in the EV segment.</p>

              <p className="bd-para bd-fade-up bd-delay-1">MG Motors' ZS EV came in second with 2,789 units sold in 2021, a more than 250 percent increase over the same period in 2020. The EV now has a 29 percent market share. Another Tata EV, the Tigor, finished third with total sales of 801 vehicles in 2021, a commendable 701 percent increase from the 100 vehicles sold in 2020. The Tigor EV, which now has a 13% market share, was upgraded earlier this year with a stronger battery and other significant improvements.</p>

              <p className="bd-para bd-fade-up bd-delay-1">Further down the road, Hyundai and Kia plan to launch a few EVs in the coming months, including a low-cost electric car that is currently in development. While the transition from traditional vehicles to EVs is much faster in two and three-wheelers, urban India remains hesitant to invest in electric vehicles. L5 electric 3W sales increased from 1612 units in 2020 to 8689 units in 2021, while state sales of electric 4W increased from 462 units in 2020 to 14218 units in 2021. With the ever-increasing price of fuel and the environmental degradation we are facing, we hope that the mindsets of these auto enthusiasts change gradually over time, as EVs are the need of the hour for a better future.</p>

              <p className="bd-para bd-fade-up bd-delay-1">Among the state-level trends seen in 2021, Uttar Pradesh had the biggest share (20%) of electric car sales, with 66,704 units sold. Karnataka, Tamil Nadu, Maharashtra, Telangana, and Rajasthan account for 67 percent of all high-speed electric 2-wheeler sales. Uttar Pradesh, Bihar, Assam, and Delhi have the most L3 category e3-wheeler sales, accounting for almost 75% of total sales, while Telangana, Karnataka, and Delhi have the most high-speed L5 category e3-wheeler sales. With 3743 units (26 percent) sold in 2021, Maharashtra has the largest anticipated electric 4-wheeler sales, followed by Delhi and Telangana, each with roughly 1900 units (13 percent) sold. Maharashtra and Gujarat will have the greatest e-Bus sales in 2021, with 552 (47%) and 216 (18%) units sold, respectively.</p>

              <p className="bd-para--quote bd-fade-up bd-delay-1">"In the entire EV journey, we haven't seen better days than the last few months." We have collectively sold approximately 1 million e2w, e-three wheelers, e-cars, and e-buses in the last 15 years, and we will most likely sell the same 1 million units in just one year beginning January 22. FAME 2's recent positive changes in EV policy are a game-changer. According to recent monthly trends, the next 12 months could see 5 to 6 times the growth of the previous 12 months," said Sohinder Gill, Director General of the Society of Manufacturers of Electric Vehicles (SMEV).</p>

              <p className="bd-para bd-fade-up bd-delay-1">The Indian automotive industry is the fifth-largest in the world, with a goal of becoming the third-largest by 2030. Relying on traditional modes of fuel-intensive mobility to serve a large domestic market will not be sustainable. To address this, federal policymakers are developing a mobility option that is "Shared, Connected, and Electric," with the goal of reaching 100 percent electrification by 2030. India stands to benefit on multiple fronts by shifting to electric vehicles (EVs): it has a relative abundance of renewable energy resources as well as skilled labour in the technology and manufacturing sectors.</p>

              <p className="bd-para bd-fade-up bd-delay-1">Many legacy OEMs are prioritizing their plugin offerings over their fossil fuel models because they need to get a foot in the door in the fast-growing plugin market now in order to ensure their survival in a future BEV-based automotive market. Individual incentives and perks provided by state and federal governments as part of the FAME II project have also increased electric car sales significantly. However, while the electric passenger vehicle segment in India is still in its infancy, demand for them is skyrocketing.</p>

            </div>
          </div>
        </section>

        {/* NEWSLETTER */}
        <Newsletter isMobile={isMobile} />

      </div>
    </>
  );
}